import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAdmin } from "@/admin/AuthContext";
import { PageHeader } from "@/components/admin/AdminUI";
import KillSwitches from "@/components/admin/KillSwitches";
import TestPushForm from "@/components/admin/TestPushForm";
import PushLog from "@/components/admin/PushLog";

export default function Notifications() {
  const { admin, permissions } = useAdmin();
  const [params] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const user = params.get("user") || "";
  const canTest = !!permissions?.users_moderate;

  return (
    <div data-testid="admin-notifications-page">
      <PageHeader title="Notifications" description="Every push attempt is logged here, including the ones that were held, skipped or stopped." />
      <div className={`mb-10 grid gap-6 ${canTest ? "lg:grid-cols-2" : ""}`}>
        <KillSwitches canEdit={admin?.role === "owner"} />
        {canTest && <TestPushForm initialUser={user} onSent={() => setRefreshKey((k) => k + 1)} />}
      </div>
      <PushLog refreshKey={refreshKey} initialUser={user} />
    </div>
  );
}
